import * as React from "react";
import { useTranslation } from 'react-i18next';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import DropZoneField from '../Config/DropZone';
import api from "../Config/HttpFeasibility";
import { Alert } from "../../../../shared/components/MiAlert";
//import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { Link } from "react-router-dom";
import es from 'date-fns/locale/es';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';
import renderRadioButtonField from '../../../../shared/components/form/RadioButton';
import Modal from '../../../../shared/components/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";


import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { DatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const RatingView = ({ history, location }) => {

    let feasibility = location.state;

    const [date, setDate] = React.useState(null);
    const [dateP, setDateP] = React.useState(null);

    const [datePFormat, setDatePFormat] = React.useState(null);
    const [dateFormat, setDateFormat] = React.useState(null);

    const [comment, setComment] = React.useState(null);

    const [file, setFile] = React.useState(null);
    const [loading, setLoadin] = React.useState(false);

    const [selected, setSelected] = React.useState(true);

    const [showModal, setShowModal] = React.useState(false);
    const [messageModal, setMessageModal] = React.useState(null);
    const [colorModal, setColorModal] = React.useState("success");

    const openModal = (success, message) => {
        if (success == true) {
            setColorModal("success");
        }
        else {
            setColorModal("danger");
        }
        setShowModal(true);
        setMessageModal(message);
    }

    const validateActuallyVisit = () => {
        try {
            if (feasibility.visita_fecha_pro != null) {
                let fecha_pro = new Date(feasibility.visita_fecha_pro);
                let fecha_pro_formateada = moment(fecha_pro).format('YYYY/MM/DD');
                setDateP(fecha_pro);
                setDatePFormat(fecha_pro_formateada);
            }

            setSelected(feasibility.visita_cali);

            if (feasibility.visita_fecha_el != null) {
                let fecha_el = new Date(feasibility.visita_fecha_el);
                let fecha_el_formateada = moment(fecha_el).format('YYYY/MM/DD');
                setDate(fecha_el);
                setDateFormat(fecha_el_formateada);
            }

            if (feasibility.visita_obs != null) {
                setComment(feasibility.visita_obs);
            }


        }
        catch (e) {
            console.error("Error con la fecha");
        }
    }

    const { t } = useTranslation('common');
    const params = location.state;

    const Loading = () => (<div class="loading">
        <div class="load__icon-wrap">
            <svg class="load__icon">
                <path fill="#a244fa" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
            </svg>
        </div>
    </div>);

    const handleFocus = (e) => {
        e.preventDefault();
        let _input = e.currentTarget;
        let _parent = _input.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_input.value.length === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const handleFocusPicker = (e) => {
        e.preventDefault();
        let _input = e.currentTarget;
        let _parent = _input.parentNode.parentNode.parentNode;
        let _label = _parent.firstChild

        if (_label.className === "form__form-group-label") {
            _label.className += " focusin"
        } else {
            if (_input.value.length === 0) {
                _label.className = "form__form-group-label";
            }
        }
    }

    const validateComment = () => {
        if (comment == null || comment.length < 1) {
            openModal(false, t('msg.observation_require'));
            return false;
        } else {
            return true;
        }
    }

    const validate = async () => {
        if (validateComment()) {
            if (file == null) {
                openModal(false, "Debes adjuntar un archivo de visita de calificación");
            } else {
                sendRequest();
            }
        }
    }

    const onValueChange = (event) => {

    }

    const sendProgrammingDate = async () => {
        if (datePFormat != null) {
            var dataProgramada = new FormData();
            dataProgramada.append("fecha_pro", datePFormat);

            fetch(process.env.REACT_APP_PUBLIC_URL + 'factibilidad/' + params.id_factibilidad + '/programar_visita', {
                method: 'POST',
                headers: {
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                'Content-Type': 'application/json',
                body: dataProgramada
            }).then(response => response.json()).then(data => {

                openModal(true, "Fecha de Visita programada");
            }).catch(error => console.error(error));
        }
        else {
            openModal(false, "Debe elegir una fecha de programación");
        }
    }

    const sendRequest = async () => {
        try {
            let usuario = JSON.parse(sessionStorage.getItem('usuario'));

            var dataVisita = new FormData();
            dataVisita.append("id_factibilidad", params.id_factibilidad);
            dataVisita.append("observaciones", comment);
            dataVisita.append("archivo", file);
            dataVisita.append("fecha_el", dateFormat);
            dataVisita.append("seleccionado", selected);
            dataVisita.append("usuario", usuario.nombre);

            fetch(process.env.REACT_APP_PUBLIC_URL + 'factibilidad/subevisita', {
                method: 'POST',
                headers: {
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                'Content-Type': 'application/json',
                body: dataVisita
            }).then(response => response.json()).then(data => {
                openModal(true, "Visita de Calificación definida");
            }).catch(error => console.error(error));
        }
        catch (e) {
            openModal(false, "Ha ocurrido un error en el sistema");
        }
    }

    const regresar = () => {
        let _url = "/clinical-studio/dashboard";
        history.push({
            pathname: process.env.PUBLIC_URL + _url,
            state: feasibility
        });
    }

    const defaultMaterialTheme = createMuiTheme({
        palette: {
            primary: {
                main: '#3EA3FC',
                contrastText: "#fff"
            },
        },
    });

    React.useEffect(() => {
        validateActuallyVisit();
    }, []);

    return (<Container>
        <Row>
            <Col md={12}>
                <h3 className="page-title center-title">{t('rating.title')}</h3>
                <h3 className="page-title center-title subhead">{params.nombre_tercero} ({params.acronimo})</h3>

                <Col md={2}>
                    <div className='top_info_buttons_hc'>
                        <div>
                            <Tooltip
                                title="Regresar al Dashboard"
                            >
                                <IconButton
                                    aria-label="upload picture"
                                    component="span"
                                    className='tooltip-top'
                                    onClick={() => {
                                        regresar();
                                    }}
                                >
                                    <ArrowBackIcon style={{ color: '#153365' }} />
                                </IconButton>
                            </Tooltip>
                            <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                        </div>
                    </div>
                </Col>

            </Col>
        </Row>

        <Card className="card--flex">
            <CardBody className="width_static">
                <div className="card__title">
                    <h5 className="bold-text">{t('rating.programming')}</h5>
                </div>
                <Row>
                    <Col md={6}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <ThemeProvider theme={defaultMaterialTheme}>
                                <DatePicker
                                    disableFuture
                                    openTo="date"
                                    label="Fecha Inicial"
                                    variant="inline"
                                    autoOk={true}
                                    views={["year", "month", "date"]}
                                    value={dateP}
                                    onChange={(value) => {
                                        let fecha_seleccionada = moment(value).format('YYYY/MM/DD');
                                        setDateP(value);
                                        setDatePFormat(fecha_seleccionada);
                                    }}
                                    className='medical-material-form__field'
                                    animateYearScrolling
                                    format="yyyy/MM/D"
                                />
                            </ThemeProvider>
                        </MuiPickersUtilsProvider>
                        <ButtonToolbar className="form__button-toolbar">
                            <Button color="primary" type="button"
                                onClick={() => sendProgrammingDate()}>
                                Programar</Button>
                        </ButtonToolbar>
                    </Col>
                </Row>
            </CardBody>
        </Card>

        <Card>
            <CardBody className="width_static">
                <div className="card__title">
                    <h5 className="bold-text">{t('rating.eligibility')}</h5>
                </div>


                <Row>
                    <Col md={6}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <ThemeProvider theme={defaultMaterialTheme}>
                                <DatePicker
                                    disableFuture
                                    openTo="date"
                                    label="Fecha Inicial"
                                    variant="inline"
                                    autoOk={true}
                                    views={["year", "month", "date"]}
                                    value={date}
                                    onChange={(value) => {
                                        let fecha_seleccionada = moment(value).format('YYYY/MM/DD');
                                        setDate(value);
                                        setDateFormat(fecha_seleccionada);
                                    }}
                                    className='medical-material-form__field'
                                    animateYearScrolling
                                    format="yyyy/MM/D"
                                />
                            </ThemeProvider>
                        </MuiPickersUtilsProvider>
                    </Col>
                    <Col md={6}>
                        <TextField
                            label="Seleccionado"
                            value={selected}
                            onChange={(event) => {
                                setSelected(event.target.value);
                            }}
                            select
                            style={{ minWidth: '100%', maxWidth: '100%' }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                                style: { color: '#646777' }
                            }}
                        >
                            <MenuItem key={0} value={true}>
                                SI
                            </MenuItem>
                            <MenuItem key={1} value={false}>
                                NO
                            </MenuItem>
                        </TextField>
                    </Col>
                    <Col md={12}>
                        <br />
                        <form className="form form_vertical" >
                            <div className="form__form-group txt-area">
                                <span className="form__form-group-label">{t('rating.observation')}</span>
                                <div className="form__form-group-field">
                                    <textarea onBlur={handleFocus} onFocus={handleFocus} value={comment}
                                        onChange={({ target: { value } }) => setComment(value)}></textarea>
                                </div>
                            </div>

                            <div className="form__form-group">
                                {loading ?
                                    <Loading />
                                    :
                                    <input accept="application/pdf" id="confidentialityFile" name="confidentialityFile" type="file" onChange={(e) => { setFile(e.target.files[0]) }} />
                                }
                            </div>
                            <ButtonToolbar className="form__button-toolbar">
                                <Button color="primary" type="button"
                                    onClick={() => validate()}>
                                    Confirmar</Button>
                            </ButtonToolbar>
                        </form>
                    </Col>
                </Row>
            </CardBody>
        </Card>

        <Modal
            color={colorModal}
            title={messageModal}
            modal={showModal}
            onOk={() => setShowModal(false)}
            toggle={() => setShowModal(false)}
        />
    </Container>);
}

export default reduxForm({
    form: 'rating_view_form', // a unique identifier for this form
})(RatingView);